import React from 'react';
import { Switch, Route, BrowserRouter } from 'react-router-dom';
import { Grid, Row, Col } from 'react-flexbox-grid';
import SteamPlayed  from './SteamPlayed';
import UserId from './UserId';
import './App.css';


function App() {
  return (
      <div className="App">
        <Grid fluid>
          <Col xs={12}>
            <Row center="xs">
              <Col xs={11}>
                <BrowserRouter>
                  <Switch>
                    <Route exact path={'/'} component={SteamPlayed} />
                    <Route exact path={'/userid/:userid'} component={UserId} />
                  </Switch>
                </BrowserRouter>
              </Col>
            </Row>
          </Col>
        </Grid>
      </div>
  );
}

export default App;
